import { Button, Typography,ButtonGroup, Grid } from '@material-ui/core'
import React, { Fragment } from 'react'
import 'fontsource-roboto';


function Nav(props) {
    const {navLinks,toFlex}=props
    const flex = toFlex? "flex":"inharent"
    return (
  
         <span style={{display:flex}}>
            {
            
            //TODO onReady
            navLinks.map(link=>{
                //TODO callBack and desing Buttons
                return       <Typography  variant="subtitle1"  key= {link.name}>
                        <a href={link.route} style={{textDecoration: "none"}}><Button  style={{margin:0,padding:0,textTransform: 'none',color:"white"}} >{link.name}</Button></a>
                    </Typography> 
                
            })
            }
            
            <a href="#prijavise" style={{textDecoration: "none"}}><Button variant="contained" color="secondary" size="small" style={{margin:0,textTransform: 'none'}}>Prijavi se</Button></a>
      
            
         
            </span>
    )
}

export default Nav
